<template>
  <div>
    <v-app-bar class="primary main-header-mobile" elevation="0">
      <div class="py-2 d-flex align-end">
        <router-link class="d-flex" to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="navbar-brand"
          />
        </router-link>
      </div>

      <v-spacer />

      <v-app-bar-nav-icon
        color="white"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer class="primary" v-model="drawer" fixed>
      <div class="px-8 py-6 d-flex flex-column">
        <router-link to="/" class="d-flex">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="mx-auto navbar-brand"
          />
        </router-link>
      </div>

      <v-list-item-group v-model="current">
        <v-list>
          <div v-for="({ text, to, href, submenu }, i) in menu" :key="i">
            <v-list-item
              v-if="!submenu"
              :to="href ? undefined : to"
              :href="href || undefined"
              link
            >
              <v-list-item-content>
                <v-list-item-title class="white--text text-body-2 nav-link">
                  {{ text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group v-else no-action :value="false">
              <template v-slot:activator>
                <v-list-item-title class="white--text text-body-2 nav-link">
                  {{ text }}
                </v-list-item-title>
              </template>

              <v-list>
                <v-list-item
                  class="pl-7"
                  v-for="({ text, to }, index) in submenu"
                  :key="index"
                  :to="to"
                  link
                >
                  <v-list-item-content>
                    <v-list-item-title class="white--text text-body-2">
                      {{ text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-list-group>
          </div>
        </v-list>
      </v-list-item-group>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  computed: {
    informations() {
      if (!this.$rest("informations").item) return "";
      return this.$rest("informations").item;
    },
  },
};
</script>

<style>
.main-header-mobile {
  z-index: 610 !important;
}

.main-header-mobile .navbar-brand {
  height: 42px;
  max-width: 50%;
}

.v-navigation-drawer__content .navbar-brand {
  height: 70px;
  max-width: 100%;
}

.v-navigation-drawer {
  z-index: 620 !important;
}

.v-list-item__icon .v-icon {
  color: #ffffff !important;
  font-size: 14px !important;
}

.v-list-group .v-list-group__items {
  background-color: var(--v-primary-darken1) !important;
}
</style>
